<template>
  <div :class="[hasVoucher?'app-main-content tab-query-page':'tab-query-page']">
    <div class="tabs-container">
      <el-tabs v-model="properties.activeTabName" type="card" style="width:100%;">
        <el-tab-pane v-if="showBatch" :label="$t('CargoMsg.Cargo_BatchProcessing')" name="batchPage">
          <batch-page v-if="showBatch" key="batchPage" ref="batchPage" :account-set="accountSet" />
        </el-tab-pane>
        <el-tab-pane v-if="jobQuery" :label="$t('CargoMsg.Cargo_Business')" name="jobQuery" :lazy="true">
          <query-job
            v-if="jobQueryIsShow"
            key="jobQuery"
            ref="jobQuery"
            identify="jobQuerySearchItem"
            view-source="VoucherList"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :show-total-group="showTotalGroup"
            :job-states="jobStates"
            :voucher-page="voucherPage"
            grid-config-module="1803011"
            :col-settings="colSettings"
            :filter-charge="filterChargeForJob"
          />
        </el-tab-pane>
        <el-tab-pane v-if="invoiceReceivable" :label="$t('CargoMsg.Cargo_ARInvoice')" name="invoiceReceivable" :lazy="true">
          <query-invoice
            v-if="invoiceReceivableIsShow"
            key="invoiceReceivable"
            ref="invoiceReceivable"
            identify="invoiceReceivableSearchItem"
            view-source="VoucherList"
            :is-ar="1"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :show-simple="false"
            :invoice-no-state="1"
            :biz-data-type="INVOICE_RECEIVABLE"
            :has-invoice-receivable-payable="hasInvoiceReceivablePayable"
            grid-config-module="1906051"
            :col-settings="colSettings"
            :input-date-start="searchConditions.inputDateStart"
            :input-date-end="searchConditions.inputDateEnd"
          >
            <template v-slot:searchAreaHeader>
              <search-area-header
                :page-mode="properties.activeTabName"
                :search-conditions="searchConditions"
              />
            </template>
          </query-invoice>
        </el-tab-pane>
        <el-tab-pane v-if="invoicePayable" :label="$t('CargoMsg.Cargo_APInvoice')" name="invoicePayable" :lazy="true">
          <query-invoice
            v-if="invoicePayableIsShow"
            key="invoicePayable"
            ref="invoicePayable"
            identify="invoicePayableSearchItem"
            view-source="VoucherList"
            :is-ar="0"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :show-simple="false"
            :invoice-no-state="-1"
            :biz-data-type="INVOICE_PAYABLE"
            :has-invoice-receivable-payable="hasInvoiceReceivablePayable"
            grid-config-module="1906052"
            :col-settings="colSettings"
            :input-date-start="searchConditions.inputDateStart"
            :input-date-end="searchConditions.inputDateEnd"
          >
            <template v-slot:searchAreaHeader>
              <search-area-header
                :page-mode="properties.activeTabName"
                :search-conditions="searchConditions"
              />
            </template>
          </query-invoice>
        </el-tab-pane>
        <el-tab-pane v-if="billingReceivable" :label="$t('CargoMsg.Cargo_ARBill')" name="billingReceivable" :lazy="true">
          <query-billing
            v-if="billingReceivableIsShow"
            key="billingReceivable"
            ref="billingReceivable"
            identify="billingReceivableSearchItem"
            view-source="VoucherList"
            :is-ar="1"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :show-simple="false"
            :oversea="1"
            :clearing-state="clearingState"
            grid-config-module="1909031"
            :col-settings="colSettings"
            :input-date-start="searchConditions.inputDateStart"
            :input-date-end="searchConditions.inputDateEnd"
          >
            <template v-slot:searchAreaHeader>
              <search-area-header
                :page-mode="properties.activeTabName"
                :search-conditions="searchConditions"
              />
            </template>
          </query-billing>
        </el-tab-pane>
        <el-tab-pane v-if="billingPayable" :label="$t('CargoMsg.Cargo_APBill')" name="billingPayable" :lazy="true">
          <query-billing
            v-if="billingPayableIsShow"
            key="billingPayable"
            ref="billingPayable"
            identify="billingPayableSearchItem"
            view-source="VoucherList"
            :is-ar="0"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :show-simple="false"
            :oversea="1"
            :clearing-state="clearingState"
            grid-config-module="1909032"
            :col-settings="colSettings"
            :input-date-start="searchConditions.inputDateStart"
            :input-date-end="searchConditions.inputDateEnd"
          >
            <template v-slot:searchAreaHeader>
              <search-area-header
                :page-mode="properties.activeTabName"
                :search-conditions="searchConditions"
              />
            </template>
          </query-billing>
        </el-tab-pane>
        <el-tab-pane v-if="billingOversea" :label="$t('CargoMsg.Cargo_InternationalBill')" name="billingOversea" :lazy="true">
          <query-billing
            v-if="billingOverseaIsShow"
            key="billingOversea"
            ref="billingOversea"
            identify="billingOverseaSearchItem"
            view-source="VoucherList"
            :is-ar="-1"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :show-simple="false"
            :oversea="1"
            :clearing-state="clearingState"
            grid-config-module="1909033"
            :col-settings="colSettings"
            :input-date-start="searchConditions.inputDateStart"
            :input-date-end="searchConditions.inputDateEnd"
          >
            <template v-slot:searchAreaHeader>
              <search-area-header
                :page-mode="properties.activeTabName"
                :search-conditions="searchConditions"
              />
            </template>
          </query-billing>
        </el-tab-pane>
        <el-tab-pane v-if="chargeReceipt" :label="$t('CargoMsg.Cargo_DomesticCollection')" name="chargeReceipt" :lazy="true">
          <query-actual-amount
            v-if="chargeReceiptIsShow"
            key="chargeReceipt"
            ref="chargeReceipt"
            identify="chargeReceiptSearchItem"
            view-source="VoucherList"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :show-simple="false"
            :ar="1"
            :oversea="0"
            :biz-data-type="RECEIPT_INTERNAL"
            grid-config-module="1910011"
            :col-settings="colSettings"
            :input-date-start="searchConditions.inputDateStart"
            :input-date-end="searchConditions.inputDateEnd"
          >
            <template v-slot:searchAreaHeader>
              <search-area-header
                :page-mode="properties.activeTabName"
                :search-conditions="searchConditions"
              />
            </template>
          </query-actual-amount>
        </el-tab-pane>
        <el-tab-pane v-if="chargePayment" :label="$t('CargoMsg.Cargo_DomesticPayment')" name="chargePayment" :lazy="true">
          <query-actual-amount
            v-if="chargePaymentIsShow"
            key="chargePayment"
            ref="chargePayment"
            identify="chargePaymentSearchItem"
            view-source="VoucherList"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :show-simple="false"
            :ar="0"
            :oversea="0"
            :biz-data-type="PAYMENT_INTERNAL"
            grid-config-module="1910012"
            :col-settings="colSettings"
            :input-date-start="searchConditions.inputDateStart"
            :input-date-end="searchConditions.inputDateEnd"
          >
            <template v-slot:searchAreaHeader>
              <search-area-header
                :page-mode="properties.activeTabName"
                :search-conditions="searchConditions"
              />
            </template>
          </query-actual-amount>
        </el-tab-pane>
        <el-tab-pane v-if="chargeReceiptForegin" :label="$t('CargoMsg.Cargo_OverseasCollection')" name="chargeReceiptForegin" :lazy="true">
          <query-actual-amount
            v-if="chargeReceiptForeginIsShow"
            key="chargeReceiptForegin"
            ref="chargeReceiptForegin"
            identify="chargeReceiptForeginSearchItem"
            view-source="VoucherList"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :show-simple="false"
            :ar="1"
            :oversea="1"
            :biz-data-type="RECEIPT_FOREGIN"
            grid-config-module="1910013"
            :col-settings="colSettings"
            :input-date-start="searchConditions.inputDateStart"
            :input-date-end="searchConditions.inputDateEnd"
          >
            <template v-slot:searchAreaHeader>
              <search-area-header
                :page-mode="properties.activeTabName"
                :search-conditions="searchConditions"
              />
            </template>
          </query-actual-amount>
        </el-tab-pane>
        <el-tab-pane v-if="chargePaymentForegin" :label="$t('CargoMsg.Cargo_OverseasPayment')" name="chargePaymentForegin" :lazy="true">
          <query-actual-amount
            v-if="chargePaymentForeginIsShow"
            key="chargePaymentForegin"
            ref="chargePaymentForegin"
            identify="chargePaymentForeginSearchItem"
            view-source="VoucherList"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :show-simple="false"
            :ar="0"
            :oversea="1"
            :biz-data-type="PAYMENT_FOREGIN"
            grid-config-module="1910014"
            :col-settings="colSettings"
            :input-date-start="searchConditions.inputDateStart"
            :input-date-end="searchConditions.inputDateEnd"
          >
            <template v-slot:searchAreaHeader>
              <search-area-header
                :page-mode="properties.activeTabName"
                :search-conditions="searchConditions"
              />
            </template>
          </query-actual-amount>
        </el-tab-pane>
        <el-tab-pane v-if="chargeReceiptPayment" :label="$t('CargoMsg.Cargo_PaidInOutOfPocket')" name="chargeReceiptPayment" :lazy="true">
          <query-actual-amount
            v-if="chargeReceiptPaymentIsShow"
            key="chargeReceiptPayment"
            ref="chargeReceiptPayment"
            identify="chargeReceiptPaymentSearchItem"
            view-source="VoucherList"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :show-simple="false"
            :ar="-1"
            :oversea="-1"
            :biz-data-type="RECEIPT_PAYMENT"
            :has-pre-receipt-payment="hasPreReceiptPayment"
            :has-charge-pre-payment="chargePrePayment"
            grid-config-module="1910015"
            :col-settings="colSettings"
            :show-invoice-detail="true"
            :show-bill-payment-detail="true"
            :input-date-start="searchConditions.inputDateStart"
            :input-date-end="searchConditions.inputDateEnd"
          >
            <template v-slot:searchAreaHeader>
              <search-area-header
                :page-mode="properties.activeTabName"
                :search-conditions="searchConditions"
              />
            </template>
          </query-actual-amount>
        </el-tab-pane>
        <el-tab-pane v-if="chargePrePayment" :label="$t('CargoMsg.Cargo_Advance')" name="chargePrePayment" :lazy="true">
          <query-actual-amount
            v-if="chargePrePaymentIsShow"
            key="chargePrePayment"
            ref="chargePrePayment"
            identify="chargePrePaymentSearchItem"
            view-source="VoucherList"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :show-simple="false"
            :ar="-1"
            :oversea="-1"
            :biz-data-type="RECEIPT_PAYMENT"
            :pre-bank-slip-states="preBankSlipStates"
            grid-config-module="1910016"
            :col-settings="colSettings"
            :input-date-start="searchConditions.inputDateStart"
            :input-date-end="searchConditions.inputDateEnd"
          >
            <template v-slot:searchAreaHeader>
              <search-area-header
                :page-mode="properties.activeTabName"
                :search-conditions="searchConditions"
              />
            </template>
          </query-actual-amount>
        </el-tab-pane>
        <el-tab-pane v-if="invoiceReceivablePayable" :label="$t('CargoMsg.Cargo_InvoiceAfterARAPOffset')" name="invoiceReceivablePayable" :lazy="true">
          <query-invoice
            v-if="invoiceReceivablePayableIsShow"
            key="invoiceReceivablePayable"
            ref="invoiceReceivablePayable"
            identify="invoiceReceivablePayableSearchItem"
            view-source="VoucherList"
            :is-ar="1"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :show-simple="false"
            :invoice-no-state="-1"
            :biz-data-type="INVOICE_RECEIVABLE_PAYABLE"
            :has-invoice-receivable-payable="hasInvoiceReceivablePayable"
            grid-config-module="1906053"
            :col-settings="colSettings"
            :input-date-start="searchConditions.inputDateStart"
            :input-date-end="searchConditions.inputDateEnd"
          >
            <template v-slot:searchAreaHeader>
              <search-area-header
                :page-mode="properties.activeTabName"
                :search-conditions="searchConditions"
              />
            </template>
          </query-invoice>
        </el-tab-pane>
        <el-tab-pane v-if="preReceiptPayment" :label="$t('CargoMsg.Cargo_VoucherOfAdvance')" name="preReceiptPayment" :lazy="true">
          <query-actual-amount
            v-if="preReceiptPaymentIsShow"
            key="preReceiptPayment"
            ref="preReceiptPayment"
            identify="preReceiptPaymentSearchItem"
            view-source="VoucherList"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :show-simple="false"
            :ar="-1"
            :oversea="-1"
            :biz-data-type="PRE_RECEIPT_PAYMENT"
            :has-pre-receipt-payment="hasPreReceiptPayment"
            :has-charge-pre-payment="chargePrePayment"
            grid-config-module="1910017"
            :col-settings="colSettings"
            :input-date-start="searchConditions.inputDateStart"
            :input-date-end="searchConditions.inputDateEnd"
          >
            <template v-slot:searchAreaHeader>
              <search-area-header
                :page-mode="properties.activeTabName"
                :search-conditions="searchConditions"
              />
            </template>
          </query-actual-amount>
        </el-tab-pane>
        <el-tab-pane v-if="preReceiptPaymentClear" :label="$t('CargoMsg.Cargo_WriteOffOfAdvance')" name="preReceiptPaymentClear" :lazy="true">
          <query-actual-amount
            v-if="preReceiptPaymentClearIsShow"
            key="preReceiptPaymentClear"
            ref="preReceiptPaymentClear"
            identify="preReceiptPaymentClearSearchItem"
            view-source="VoucherList"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :show-simple="false"
            :ar="-1"
            :oversea="-1"
            :biz-data-type="PRE_RECEIPT_PAYMENT_CLEAR"
            :has-pre-receipt-payment="hasPreReceiptPayment"
            :has-charge-pre-payment="chargePrePayment"
            grid-config-module="1910018"
            :col-settings="colSettings"
            :input-date-start="searchConditions.inputDateStart"
            :input-date-end="searchConditions.inputDateEnd"
          >
            <template v-slot:searchAreaHeader>
              <search-area-header
                :page-mode="properties.activeTabName"
                :search-conditions="searchConditions"
              />
            </template>
          </query-actual-amount>
        </el-tab-pane>
        <el-tab-pane v-if="billPaymentQuery" :label="$t('CargoMsg.Cargo_PaymentRequest')" name="billPaymentQuery" :lazy="true">
          <query-bill-payment
            v-if="billPaymentQueryIsShow"
            key="billPaymentQuery"
            ref="billPaymentQuery"
            identify="billPaymentQuerySearchItem"
            view-source="VoucherList"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :state="billPaymentState"
            :show-simple="false"
            grid-config-module="1908011"
            :col-settings="colSettings"
            :input-date-start="searchConditions.inputDateStart"
            :input-date-end="searchConditions.inputDateEnd"
          >
            <template v-slot:searchAreaHeader>
              <search-area-header
                :page-mode="properties.activeTabName"
                :search-conditions="searchConditions"
              />
            </template>
          </query-bill-payment>
        </el-tab-pane>
        <el-tab-pane v-if="receiptPaymentOffset" :label="$t('CargoMsg.Cargo_ReceiptPaymentOffset')" name="receiptPaymentOffset" :lazy="true">
          <query-actual-amount
            v-if="receiptPaymentOffsetIsShow"
            key="receiptPaymentOffset"
            ref="receiptPaymentOffset"
            identify="receiptPaymentOffsetSearchItem"
            view-source="VoucherList"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :show-simple="false"
            :ar="-1"
            :oversea="-1"
            :biz-data-type="RECEIPT_PAYMENT_OFFSET"
            :has-pre-receipt-payment="hasPreReceiptPayment"
            grid-config-module="1910019"
            :col-settings="colSettings"
            :show-invoice-detail="true"
            :input-date-start="searchConditions.inputDateStart"
            :input-date-end="searchConditions.inputDateEnd"
          >
            <template v-slot:searchAreaHeader>
              <search-area-header
                :page-mode="properties.activeTabName"
                :search-conditions="searchConditions"
              />
            </template>
          </query-actual-amount>
        </el-tab-pane>
        <el-tab-pane v-if="invoicePayableOffset" :label="$t('CargoMsg.Cargo_InvoicePayableOffset')" name="invoicePayableOffset" :lazy="true">
          <query-invoice
            v-if="invoicePayableOffsetIsShow"
            key="invoicePayableOffset"
            ref="invoicePayableOffset"
            identify="invoicePayableOffsetSearchItem"
            view-source="VoucherList"
            :is-ar="0"
            :is-ext="isExt"
            :account-set-key="accountSet.uuid"
            :account-set-branch-id="accountSetBranchId"
            :has-voucher="hasVoucher"
            :show-simple="false"
            :invoice-no-state="-1"
            :biz-data-type="INVOICE_PAYABLE_OFFSET"
            :has-invoice-receivable-payable="hasInvoiceReceivablePayable"
            grid-config-module="1906054"
            :col-settings="colSettings"
            :input-date-start="searchConditions.inputDateStart"
            :input-date-end="searchConditions.inputDateEnd"
          >
            <template v-slot:searchAreaHeader>
              <search-area-header
                :page-mode="properties.activeTabName"
                :search-conditions="searchConditions"
              />
            </template>
          </query-invoice>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import BatchPage from '@/views/cargo/v0/FinanceManage/VoucherMaintenance/BatchPage'
import QueryJob from '@/views/cargo/v0/Clearing/components/query/queryJob'
import QueryInvoice from '@/views/cargo/v0/Clearing/components/query/queryInvoice'
import QueryBilling from '@/views/cargo/v0/Clearing/components/query/queryBilling'
import QueryActualAmount from '@/views/cargo/v0/Clearing/components/query/queryActualAmount'
import QueryBillPayment from '@/views/cargo/v0/Clearing/components/query/queryBillPayment'
import SearchAreaHeader from '@/views/cargo/v0/FinanceManage/VoucherMaintenance/searchAreaHeader'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import moment from 'moment'

export default {
  name: 'TabQueryPage',
  components: { BatchPage, QueryJob, QueryInvoice, QueryBilling, QueryActualAmount, QueryBillPayment, SearchAreaHeader },
  props: {
    isExt: { type: Boolean, default: false },
    accountSet: { type: Object }, // 账套
    hasVoucher: { type: Number, default: 0 }, // 是否已经生成过凭证:1=是,0=否
    showBatch: { type: Boolean, default: true }, // 是否显示批量操作
    showTotalGroup: { type: Boolean, default: true }, // 是否显示利润
    showVoucherDate: { type: Boolean, default: false }, // 显示生成凭证日期
    preBankSlipStates: { type: Array, default: () => [] }, // 预收款状态
    voucherPage: { type: Number, default: 2 },
    properties: { type: Object },
    colSettings: { type: Object },
    filterChargeForJob: { type: Boolean, default: false } // 对于业务页签是否要筛选费用
  },
  data() {
    return {
      jobQuery: this.hasRule(FinanceInterfaceConstants.BIZ_REVENUE.code) || this.hasRule(FinanceInterfaceConstants.BIZ_COST.code) || this.hasRule(FinanceInterfaceConstants.BIZ_COST_REVENUE.code),
      invoiceReceivable: this.hasRule(FinanceInterfaceConstants.INVOICE_RECEIVABLE.code),
      invoicePayable: this.hasRule(FinanceInterfaceConstants.INVOICE_PAYABLE.code),
      billingReceivable: this.hasRule(FinanceInterfaceConstants.BILLING_RECEIVABLE.code),
      billingPayable: this.hasRule(FinanceInterfaceConstants.BILLING_PAYABLE.code),
      billingOversea: this.hasRule(FinanceInterfaceConstants.BILLING_OVERSEA.code),
      chargeReceipt: this.hasRule(FinanceInterfaceConstants.RECEIPT_INTERNAL.code),
      chargePayment: this.hasRule(FinanceInterfaceConstants.PAYMENT_INTERNAL.code),
      chargeReceiptForegin: this.hasRule(FinanceInterfaceConstants.RECEIPT_FOREGIN.code),
      chargePaymentForegin: this.hasRule(FinanceInterfaceConstants.PAYMENT_FOREGIN.code),
      chargeReceiptPayment: this.hasRule(FinanceInterfaceConstants.RECEIPT_PAYMENT.code),
      chargePrePayment: this.$store.getters.tenantId === 2555 || this.$store.getters.tenantId === 18178,
      invoiceReceivablePayable: this.hasRule(FinanceInterfaceConstants.INVOICE_RECEIVABLE_PAYABLE.code),
      preReceiptPayment: this.hasRule(FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT.code),
      preReceiptPaymentClear: this.hasRule(FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT_CLEAR.code),
      billPaymentQuery: this.hasRule(FinanceInterfaceConstants.BILLPAYMENT.code),
      receiptPaymentOffset: this.hasRule(FinanceInterfaceConstants.RECEIPT_PAYMENT_OFFSET.code),
      invoicePayableOffset: this.hasRule(FinanceInterfaceConstants.INVOICE_PAYABLE_OFFSET.code),
      jobQueryIsShowed: false,
      invoiceReceivableIsShowed: false,
      invoicePayableIsShowed: false,
      billingReceivableIsShowed: false,
      billingPayableIsShowed: false,
      billingOverseaIsShowed: false,
      chargeReceiptIsShowed: false,
      chargePaymentIsShowed: false,
      chargeReceiptForeginIsShowed: false,
      chargePaymentForeginIsShowed: false,
      chargeReceiptPaymentIsShowed: false,
      chargePrePaymentIsShowed: false,
      invoiceReceivablePayableIsShowed: false,
      preReceiptPaymentIsShowed: false,
      preReceiptPaymentClearIsShowed: false,
      billPaymentQueryIsShowed: false,
      receiptPaymentOffsetIsShowed: false,
      invoicePayableOffsetIsShowed: false,
      searchConditions: {
        inputDateStart: moment().subtract(2, 'y').format('yyyy-MM-DD'),
        inputDateEnd: ''
      },
      paymentApplicationSendingCloudPlatform: false // 是否开启申请付款发送云平台功能
    }
  },
  computed: {
    jobQueryIsShow() {
      if (this.properties.activeTabName === 'jobQuery' && !this.jobQueryIsShowed) {
        this.jobQueryIsShowed = true
      }
      return this.jobQueryIsShowed
    },
    invoiceReceivableIsShow() {
      if (this.properties.activeTabName === 'invoiceReceivable' && !this.invoiceReceivableIsShowed) {
        this.invoiceReceivableIsShowed = true
      }
      return this.invoiceReceivableIsShowed
    },
    invoicePayableIsShow() {
      if (this.properties.activeTabName === 'invoicePayable' && !this.invoicePayableIsShowed) {
        this.invoicePayableIsShowed = true
      }
      return this.invoicePayableIsShowed
    },
    billingReceivableIsShow() {
      if (this.properties.activeTabName === 'billingReceivable' && !this.billingReceivableIsShowed) {
        this.billingReceivableIsShowed = true
      }
      return this.billingReceivableIsShowed
    },
    billingPayableIsShow() {
      if (this.properties.activeTabName === 'billingPayable' && !this.billingPayableIsShowed) {
        this.billingPayableIsShowed = true
      }
      return this.billingPayableIsShowed
    },
    billingOverseaIsShow() {
      if (this.properties.activeTabName === 'billingOversea' && !this.billingOverseaIsShowed) {
        this.billingOverseaIsShowed = true
      }
      return this.billingOverseaIsShowed
    },
    chargeReceiptIsShow() {
      if (this.properties.activeTabName === 'chargeReceipt' && !this.chargeReceiptIsShowed) {
        this.chargeReceiptIsShowed = true
      }
      return this.chargeReceiptIsShowed
    },
    chargePaymentIsShow() {
      if (this.properties.activeTabName === 'chargePayment' && !this.chargePaymentIsShowed) {
        this.chargePaymentIsShowed = true
      }
      return this.chargePaymentIsShowed
    },
    chargeReceiptForeginIsShow() {
      if (this.properties.activeTabName === 'chargeReceiptForegin' && !this.chargeReceiptForeginIsShowed) {
        this.chargeReceiptForeginIsShowed = true
      }
      return this.chargeReceiptForeginIsShowed
    },
    chargePaymentForeginIsShow() {
      if (this.properties.activeTabName === 'chargePaymentForegin' && !this.chargePaymentForeginIsShowed) {
        this.chargePaymentForeginIsShowed = true
      }
      return this.chargePaymentForeginIsShowed
    },
    chargeReceiptPaymentIsShow() {
      if (this.properties.activeTabName === 'chargeReceiptPayment' && !this.chargeReceiptPaymentIsShowed) {
        this.chargeReceiptPaymentIsShowed = true
      }
      return this.chargeReceiptPaymentIsShowed
    },
    chargePrePaymentIsShow() {
      if (this.properties.activeTabName === 'chargePrePayment' && !this.chargePrePaymentIsShowed) {
        this.chargePrePaymentIsShowed = true
      }
      return this.chargePrePaymentIsShowed
    },
    invoiceReceivablePayableIsShow() {
      if (this.properties.activeTabName === 'invoiceReceivablePayable' && !this.invoiceReceivablePayableIsShowed) {
        this.invoiceReceivablePayableIsShowed = true
      }
      return this.invoiceReceivablePayableIsShowed
    },
    preReceiptPaymentIsShow() {
      if (this.properties.activeTabName === 'preReceiptPayment' && !this.preReceiptPaymentIsShowed) {
        this.preReceiptPaymentIsShowed = true
      }
      return this.preReceiptPaymentIsShowed
    },
    preReceiptPaymentClearIsShow() {
      if (this.properties.activeTabName === 'preReceiptPaymentClear' && !this.preReceiptPaymentClearIsShowed) {
        this.preReceiptPaymentClearIsShowed = true
      }
      return this.preReceiptPaymentClearIsShowed
    },
    billPaymentQueryIsShow() {
      if (this.properties.activeTabName === 'billPaymentQuery' && !this.billPaymentQueryIsShowed) {
        this.billPaymentQueryIsShowed = true
      }
      return this.billPaymentQueryIsShowed
    },
    receiptPaymentOffsetIsShow() {
      if (this.properties.activeTabName === 'receiptPaymentOffset' && !this.receiptPaymentOffsetIsShowed) {
        this.receiptPaymentOffsetIsShowed = true
      }
      return this.receiptPaymentOffsetIsShowed
    },
    invoicePayableOffsetIsShow() {
      if (this.properties.activeTabName === 'invoicePayableOffset' && !this.invoicePayableOffsetIsShowed) {
        this.invoicePayableOffsetIsShowed = true
      }
      return this.invoicePayableOffsetIsShowed
    },
    // 是否海外结算中心分录
    hasOverSea() {
      let hasOverSea = false
      for (const rule of this.accountSet.accountingEntryRule) {
        if (rule.entryType === FinanceInterfaceConstants.ACCOUNT_RECEIVABLE_OVERSEA.code ||
          rule.entryType === FinanceInterfaceConstants.ACCOUNT_PAYABLE_OVERSEA.code ||
          rule.entryType === FinanceInterfaceConstants.OTHERS_RECEIVABLE_CENTER.code ||
          rule.entryType === FinanceInterfaceConstants.OTHERS_PAYABLE_CENTER.code) {
          hasOverSea = true
          break
        }
      }
      return hasOverSea
    },
    clearingState() {
      return (this.isExt || this.hasOverSea) ? -1 : ClearingConstants.CLEARING_STATE_FULL.code
    },
    hasPreReceiptPayment() {
      return this.hasRule(FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT.code) || this.hasRule(FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT_CLEAR.code)
    },
    RECEIPT_INTERNAL() {
      return FinanceInterfaceConstants.RECEIPT_INTERNAL.code
    },
    PAYMENT_INTERNAL() {
      return FinanceInterfaceConstants.PAYMENT_INTERNAL.code
    },
    RECEIPT_FOREGIN() {
      return FinanceInterfaceConstants.RECEIPT_FOREGIN.code
    },
    PAYMENT_FOREGIN() {
      return FinanceInterfaceConstants.PAYMENT_FOREGIN.code
    },
    RECEIPT_PAYMENT() {
      return FinanceInterfaceConstants.RECEIPT_PAYMENT.code
    },
    PRE_RECEIPT_PAYMENT() {
      return FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT.code
    },
    PRE_RECEIPT_PAYMENT_CLEAR() {
      return FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT_CLEAR.code
    },
    INVOICE_RECEIVABLE() {
      return FinanceInterfaceConstants.INVOICE_RECEIVABLE.code
    },
    INVOICE_PAYABLE() {
      return FinanceInterfaceConstants.INVOICE_PAYABLE.code
    },
    INVOICE_RECEIVABLE_PAYABLE() {
      return FinanceInterfaceConstants.INVOICE_RECEIVABLE_PAYABLE.code
    },
    RECEIPT_PAYMENT_OFFSET() {
      return FinanceInterfaceConstants.RECEIPT_PAYMENT_OFFSET.code
    },
    INVOICE_PAYABLE_OFFSET() {
      return FinanceInterfaceConstants.INVOICE_PAYABLE_OFFSET.code
    },
    hasInvoiceReceivablePayable() {
      return this.hasRule(FinanceInterfaceConstants.INVOICE_RECEIVABLE_PAYABLE.code) || this.hasRule(FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT_CLEAR.code)
    },
    jobStates() {
      return [SystemConstants.VERIFYING_AUDITED]
    },
    billPaymentState() {
      return this.paymentApplicationSendingCloudPlatform ? [ClearingConstants.BILL_PAYMENT_WEAVER_APPROVED.code] : [ClearingConstants.BILL_PAYMENT_FINANCE_VERIFIED.code]
    },
    accountSetBranchId() {
      if (this.accountSet && RateUtil.useOrderCenterMode()) {
        return this.accountSet.branchId
      } else {
        return 0
      }
    }
  },
  created() {
    cache.load(cacheName.CONFIG)
    this.initConfig()
  },
  methods: {
    // 配置参数
    initConfig() {
      this.paymentApplicationSendingCloudPlatform = Number(cache.config.get('PaymentApplicationSendingCloudPlatform')) === 1
    },
    hasRule(type) {
      let has = false
      for (const rule of this.accountSet.accountingDocumentsRule) {
        if (rule.businessDataType === type) {
          has = true
          break
        }
      }
      return has
    },
    // 获取勾选的项目
    getSelections() {
      switch (this.properties.activeTabName) {
        case 'jobQuery': return this.$refs.jobQuery.getSelections()
          break
        case 'invoiceReceivable': return this.$refs.invoiceReceivable.getSelections()
          break
        case 'invoicePayable': return this.$refs.invoicePayable.getSelections()
          break
        case 'billingReceivable': return this.$refs.billingReceivable.getSelections()
          break
        case 'billingPayable': return this.$refs.billingPayable.getSelections()
          break
        case 'billingOversea': return this.$refs.billingOversea.getSelections()
          break
        case 'chargeReceipt': return this.$refs.chargeReceipt.getSelections()
          break
        case 'chargePayment': return this.$refs.chargePayment.getSelections()
          break
        case 'chargeReceiptForegin': return this.$refs.chargeReceiptForegin.getSelections()
          break
        case 'chargePaymentForegin': return this.$refs.chargePaymentForegin.getSelections()
          break
        case 'chargeReceiptPayment': return this.$refs.chargeReceiptPayment.getSelections()
          break
        case 'chargePrePayment': return this.$refs.chargePrePayment.getSelections()
          break
        case 'invoiceReceivablePayable': return this.$refs.invoiceReceivablePayable.getSelections()
          break
        case 'preReceiptPayment': return this.$refs.preReceiptPayment.getSelections()
          break
        case 'preReceiptPaymentClear': return this.$refs.preReceiptPaymentClear.getSelections()
          break
        case 'billPaymentQuery': return this.$refs.billPaymentQuery.getSelections()
          break
        case 'receiptPaymentOffset': return this.$refs.receiptPaymentOffset.getSelections()
          break
        case 'invoicePayableOffset': return this.$refs.invoicePayableOffset.getSelections()
          break
        default: return []
          break
      }
    },
    // 凭证类型
    bizDataType() {
      switch (this.properties.activeTabName) {
        case 'jobQuery': return FinanceInterfaceConstants.BIZ_COST.code
          break
        case 'invoiceReceivable': return FinanceInterfaceConstants.INVOICE_RECEIVABLE.code
          break
        case 'invoicePayable': return FinanceInterfaceConstants.INVOICE_PAYABLE.code
          break
        case 'billingReceivable': return FinanceInterfaceConstants.BILLING_RECEIVABLE.code
          break
        case 'billingPayable': return FinanceInterfaceConstants.BILLING_PAYABLE.code
          break
        case 'billingOversea': return FinanceInterfaceConstants.BILLING_OVERSEA.code
          break
        case 'chargeReceipt': return FinanceInterfaceConstants.RECEIPT_INTERNAL.code
          break
        case 'chargePayment': return FinanceInterfaceConstants.PAYMENT_INTERNAL.code
          break
        case 'chargeReceiptForegin': return FinanceInterfaceConstants.RECEIPT_FOREGIN.code
          break
        case 'chargePaymentForegin': return FinanceInterfaceConstants.PAYMENT_FOREGIN.code
          break
        case 'chargeReceiptPayment': return FinanceInterfaceConstants.RECEIPT_PAYMENT.code
          break
        case 'chargePrePayment': return FinanceInterfaceConstants.RECEIPT_PAYMENT.code
          break
        case 'invoiceReceivablePayable': return FinanceInterfaceConstants.INVOICE_RECEIVABLE_PAYABLE.code
          break
        case 'preReceiptPayment': return FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT.code
          break
        case 'preReceiptPaymentClear': return FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT_CLEAR.code
          break
        case 'billPaymentQuery': return FinanceInterfaceConstants.BILLPAYMENT.code
          break
        case 'receiptPaymentOffset': return FinanceInterfaceConstants.RECEIPT_PAYMENT_OFFSET.code
          break
        case 'invoicePayableOffset': return FinanceInterfaceConstants.INVOICE_PAYABLE_OFFSET.code
          break
        default: return 0
          break
      }
    },
    // 是否红冲
    isRedPunch() {
      switch (this.properties.activeTabName) {
        case 'jobQuery': return this.$refs.jobQuery.isRedPunch()
          break
        case 'invoiceReceivable': return this.$refs.invoiceReceivable.isRedPunch()
          break
        case 'invoicePayable': return this.$refs.invoicePayable.isRedPunch()
          break
        case 'billingReceivable': return this.$refs.billingReceivable.isRedPunch()
          break
        case 'billingPayable': return this.$refs.billingPayable.isRedPunch()
          break
        case 'billingOversea': return this.$refs.billingOversea.isRedPunch()
          break
        case 'chargeReceipt': return this.$refs.chargeReceipt.isRedPunch()
          break
        case 'chargePayment': return this.$refs.chargePayment.isRedPunch()
          break
        case 'chargeReceiptForegin': return this.$refs.chargeReceiptForegin.isRedPunch()
          break
        case 'chargePaymentForegin': return this.$refs.chargePaymentForegin.isRedPunch()
          break
        case 'chargeReceiptPayment': return this.$refs.chargeReceiptPayment.isRedPunch()
          break
        case 'chargePrePayment': return this.$refs.chargePrePayment.isRedPunch()
          break
        case 'invoiceReceivablePayable': return this.$refs.invoiceReceivablePayable.isRedPunch()
          break
        case 'preReceiptPayment': return this.$refs.preReceiptPayment.isRedPunch()
          break
        case 'preReceiptPaymentClear': return this.$refs.preReceiptPaymentClear.isRedPunch()
          break
        case 'billPaymentQuery': return this.$refs.billPaymentQuery.isRedPunch()
          break
        case 'receiptPaymentOffset': return this.$refs.receiptPaymentOffset.isRedPunch()
          break
        case 'invoicePayableOffset': return this.$refs.invoicePayableOffset.isRedPunch()
          break
        default: return false
          break
      }
    },
    // 查询条件
    extraConditions() {
      switch (this.properties.activeTabName) {
        case 'jobQuery': return this.$refs.jobQuery.searchConditions.snapshotConditions
          break
        case 'invoiceReceivable': return this.$refs.invoiceReceivable.searchConditions.snapshotConditions
          break
        case 'invoicePayable': return this.$refs.invoicePayable.searchConditions.snapshotConditions
          break
        case 'billingReceivable': return this.$refs.billingReceivable.searchConditions.snapshotConditions
          break
        case 'billingPayable': return this.$refs.billingPayable.searchConditions.snapshotConditions
          break
        case 'billingOversea': return this.$refs.billingOversea.searchConditions.snapshotConditions
          break
        case 'chargeReceipt': return this.$refs.chargeReceipt.conditionsAndRequires.conditions
          break
        case 'chargePayment': return this.$refs.chargePayment.conditionsAndRequires.conditions
          break
        case 'chargeReceiptForegin': return this.$refs.chargeReceiptForegin.conditionsAndRequires.conditions
          break
        case 'chargePaymentForegin': return this.$refs.chargePaymentForegin.conditionsAndRequires.conditions
          break
        case 'chargeReceiptPayment': return this.$refs.chargeReceiptPayment.conditionsAndRequires.conditions
          break
        case 'chargePrePayment': return this.$refs.chargePrePayment.conditionsAndRequires.conditions
          break
        case 'invoiceReceivablePayable': return this.$refs.invoiceReceivablePayable.searchConditions.snapshotConditions
          break
        case 'preReceiptPayment': return this.$refs.preReceiptPayment.conditionsAndRequires.conditions
          break
        case 'preReceiptPaymentClear': return this.$refs.preReceiptPaymentClear.conditionsAndRequires.conditions
          break
        case 'billPaymentQuery': return this.$refs.billPaymentQuery.searchConditions.snapshotConditions
          break
        case 'receiptPaymentOffset': return this.$refs.receiptPaymentOffset.conditionsAndRequires.conditions
          break
        case 'invoicePayableOffset': return this.$refs.invoicePayableOffset.searchConditions.snapshotConditions
          break
        default: return []
          break
      }
    },
    // 获取选择的分录
    bizTypes() {
      if (this.properties.activeTabName === 'batchPage') {
        return this.$refs.batchPage.bizTypes()
      } else {
        return []
      }
    },
    // 开始日期
    startDate() {
      if (this.properties.activeTabName === 'batchPage') {
        return this.$refs.batchPage.startDate
      } else {
        return null
      }
    },
    // 结束日期
    endDate() {
      if (this.properties.activeTabName === 'batchPage') {
        return this.$refs.batchPage.endDate
      } else {
        return null
      }
    },
    // 是否导出
    isExport() {
      if (this.properties.activeTabName === 'batchPage') {
        return this.$refs.batchPage.isExport
      } else {
        return false
      }
    },
    // 验证
    validate() {
      return this.$refs.batchPage.validate()
    },
    // 重置
    resetRowData() {
      if (this.$refs.jobQuery) {
        this.$refs.jobQuery.rowData = []
        this.$refs.jobQuery.selectionCountLabel = ''
        this.$refs.jobQuery.financeManageHP.totalGroupIncome.dataProvider = []
        this.$refs.jobQuery.financeManageHP.totalGroupCost.dataProvider = []
        this.$refs.jobQuery.financeManageHP.totalGroup.dataProvider = []
        this.$refs.jobQuery.financeManageHP.chargeCountGroup.dataProvider = []
        this.$refs.jobQuery.searchConditions.total = 0
        this.$refs.jobQuery.searchConditions.pageCount = 0
        this.$refs.jobQuery.searchConditions.pageNum = 1
      }
      if (this.$refs.invoiceReceivable) {
        this.$refs.invoiceReceivable.rowData = []
        this.$refs.invoiceReceivable.totalAmountToCurrencyInvoiceGrid.labelText = ''
        this.$refs.invoiceReceivable.totalAmountToCurrencyInvoiceGrid.selectionCountLabel = ''
        this.$refs.invoiceReceivable.totalAmountToCurrencyInvoiceGrid.dataProvider = []
        this.$refs.invoiceReceivable.totalAmountToCurrencyInvoiceGrid.selectedCount = 0
        this.$refs.invoiceReceivable.searchConditions.total = 0
        this.$refs.invoiceReceivable.searchConditions.pageNum = 1
      }
      if (this.$refs.invoicePayable) {
        this.$refs.invoicePayable.rowData = []
        this.$refs.invoicePayable.totalAmountToCurrencyInvoiceGrid.labelText = ''
        this.$refs.invoicePayable.totalAmountToCurrencyInvoiceGrid.selectionCountLabel = ''
        this.$refs.invoicePayable.totalAmountToCurrencyInvoiceGrid.dataProvider = []
        this.$refs.invoicePayable.totalAmountToCurrencyInvoiceGrid.selectedCount = 0
        this.$refs.invoicePayable.searchConditions.total = 0
        this.$refs.invoicePayable.searchConditions.pageNum = 1
      }
      if (this.$refs.billingReceivable) {
        this.$refs.billingReceivable.rowData = []
        this.$refs.billingReceivable.totalAmountToCurrencyBillingGrid.labelText = ''
        this.$refs.billingReceivable.totalAmountToCurrencyBillingGrid.selectionCountLabel = ''
        this.$refs.billingReceivable.totalAmountToCurrencyBillingGrid.dataProvider = []
        this.$refs.billingReceivable.totalAmountToCurrencyBillingGrid.selectedCount = 0
        this.$refs.billingReceivable.searchConditions.total = 0
        this.$refs.billingReceivable.searchConditions.pageNum = 1
      }
      if (this.$refs.billingPayable) {
        this.$refs.billingPayable.rowData = []
        this.$refs.billingPayable.totalAmountToCurrencyBillingGrid.labelText = ''
        this.$refs.billingPayable.totalAmountToCurrencyBillingGrid.selectionCountLabel = ''
        this.$refs.billingPayable.totalAmountToCurrencyBillingGrid.dataProvider = []
        this.$refs.billingPayable.totalAmountToCurrencyBillingGrid.selectedCount = 0
        this.$refs.billingPayable.searchConditions.total = 0
        this.$refs.billingPayable.searchConditions.pageNum = 1
      }
      if (this.$refs.billingOversea) {
        this.$refs.billingOversea.rowData = []
        this.$refs.billingOversea.totalAmountToCurrencyBillingGrid.labelText = ''
        this.$refs.billingOversea.totalAmountToCurrencyBillingGrid.selectionCountLabel = ''
        this.$refs.billingOversea.totalAmountToCurrencyBillingGrid.dataProvider = []
        this.$refs.billingOversea.totalAmountToCurrencyBillingGrid.selectedCount = 0
        this.$refs.billingOversea.searchConditions.total = 0
        this.$refs.billingOversea.searchConditions.pageNum = 1
      }
      if (this.$refs.chargeReceipt) {
        this.$refs.chargeReceipt.rowData = []
        this.$refs.chargeReceipt.totalAmountToCurrency.selectionCountLabel = ''
        this.$refs.chargeReceipt.totalAmountToCurrency.dataProvider = []
        this.$refs.chargeReceipt.pageConditions.total = 0
        this.$refs.chargeReceipt.pageConditions.pageNum = 1
      }
      if (this.$refs.chargePayment) {
        this.$refs.chargePayment.rowData = []
        this.$refs.chargePayment.totalAmountToCurrency.selectionCountLabel = ''
        this.$refs.chargePayment.totalAmountToCurrency.dataProvider = []
        this.$refs.chargePayment.pageConditions.total = 0
        this.$refs.chargePayment.pageConditions.pageNum = 1
      }
      if (this.$refs.chargeReceiptForegin) {
        this.$refs.chargeReceiptForegin.rowData = []
        this.$refs.chargeReceiptForegin.totalAmountToCurrency.selectionCountLabel = ''
        this.$refs.chargeReceiptForegin.totalAmountToCurrency.dataProvider = []
        this.$refs.chargeReceiptForegin.pageConditions.total = 0
        this.$refs.chargeReceiptForegin.pageConditions.pageNum = 1
      }
      if (this.$refs.chargePaymentForegin) {
        this.$refs.chargePaymentForegin.rowData = []
        this.$refs.chargePaymentForegin.totalAmountToCurrency.selectionCountLabel = ''
        this.$refs.chargePaymentForegin.totalAmountToCurrency.dataProvider = []
        this.$refs.chargePaymentForegin.pageConditions.total = 0
        this.$refs.chargePaymentForegin.pageConditions.pageNum = 1
      }
      if (this.$refs.chargeReceiptPayment) {
        this.$refs.chargeReceiptPayment.rowData = []
        this.$refs.chargeReceiptPayment.totalAmountToCurrency.selectionCountLabel = ''
        this.$refs.chargeReceiptPayment.totalAmountToCurrency.dataProvider = []
        this.$refs.chargeReceiptPayment.pageConditions.total = 0
        this.$refs.chargeReceiptPayment.pageConditions.pageNum = 1
      }
      if (this.$refs.chargePrePayment) {
        this.$refs.chargePrePayment.rowData = []
        this.$refs.chargePrePayment.totalAmountToCurrency.selectionCountLabel = ''
        this.$refs.chargePrePayment.totalAmountToCurrency.dataProvider = []
        this.$refs.chargePrePayment.pageConditions.total = 0
        this.$refs.chargePrePayment.pageConditions.pageNum = 1
      }
      if (this.$refs.invoiceReceivablePayable) {
        this.$refs.invoiceReceivablePayable.rowData = []
        this.$refs.invoiceReceivablePayable.totalAmountToCurrencyInvoiceGrid.labelText = ''
        this.$refs.invoiceReceivablePayable.totalAmountToCurrencyInvoiceGrid.selectionCountLabel = ''
        this.$refs.invoiceReceivablePayable.totalAmountToCurrencyInvoiceGrid.dataProvider = []
        this.$refs.invoiceReceivablePayable.totalAmountToCurrencyInvoiceGrid.selectedCount = 0
        this.$refs.invoiceReceivablePayable.searchConditions.total = 0
        this.$refs.invoiceReceivablePayable.searchConditions.pageNum = 1
      }
      if (this.$refs.preReceiptPayment) {
        this.$refs.preReceiptPayment.rowData = []
        this.$refs.preReceiptPayment.totalAmountToCurrency.selectionCountLabel = ''
        this.$refs.preReceiptPayment.totalAmountToCurrency.dataProvider = []
        this.$refs.preReceiptPayment.pageConditions.total = 0
        this.$refs.preReceiptPayment.pageConditions.pageNum = 1
      }
      if (this.$refs.preReceiptPaymentClear) {
        this.$refs.preReceiptPaymentClear.rowData = []
        this.$refs.preReceiptPaymentClear.totalAmountToCurrency.selectionCountLabel = ''
        this.$refs.preReceiptPaymentClear.totalAmountToCurrency.dataProvider = []
        this.$refs.preReceiptPaymentClear.pageConditions.total = 0
        this.$refs.preReceiptPaymentClear.pageConditions.pageNum = 1
      }
      if (this.$refs.billPaymentQuery) {
        this.$refs.billPaymentQuery.billPaymentGrid.rowData = []
        this.$refs.billPaymentQuery.totalAmountToCurrencyBillPaymentGrid.labelText = ''
        this.$refs.billPaymentQuery.totalAmountToCurrencyBillPaymentGrid.selectionCountLabel = ''
        this.$refs.billPaymentQuery.totalAmountToCurrencyBillPaymentGrid.dataProvider = []
        this.$refs.billPaymentQuery.searchConditions.total = 0
        this.$refs.billPaymentQuery.searchConditions.pageNum = 1
      }
      if (this.$refs.receiptPaymentOffset) {
        this.$refs.receiptPaymentOffset.rowData = []
        this.$refs.receiptPaymentOffset.totalAmountToCurrency.selectionCountLabel = ''
        this.$refs.receiptPaymentOffset.totalAmountToCurrency.dataProvider = []
        this.$refs.receiptPaymentOffset.pageConditions.total = 0
        this.$refs.receiptPaymentOffset.pageConditions.pageNum = 1
      }
      if (this.$refs.invoicePayableOffset) {
        this.$refs.invoicePayableOffset.rowData = []
        this.$refs.invoicePayableOffset.totalAmountToCurrencyInvoiceGrid.labelText = ''
        this.$refs.invoicePayableOffset.totalAmountToCurrencyInvoiceGrid.selectionCountLabel = ''
        this.$refs.invoicePayableOffset.totalAmountToCurrencyInvoiceGrid.dataProvider = []
        this.$refs.invoicePayableOffset.totalAmountToCurrencyInvoiceGrid.selectedCount = 0
        this.$refs.invoicePayableOffset.searchConditions.total = 0
        this.$refs.invoicePayableOffset.searchConditions.pageNum = 1
      }
    }
  }
}
</script>

<style lang="scss">
</style>
